import { useLang } from "@/i18n/LanguageContext";
import { LANGUAGES } from "@/i18n/translations";

// Compact language switcher (CZ / EN / DE)
export const LanguageSwitcher = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div
      className={`inline-flex items-center rounded-full border border-white/10 bg-white/5 p-0.5 ${className}`}
      data-testid="language-switcher"
    >
      {LANGUAGES.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => setLang(l.code)}
          className={`px-2.5 py-1 text-xs font-semibold rounded-full transition-colors ${
            lang === l.code
              ? "bg-indigo-500 text-white"
              : "text-zinc-400 hover:text-white"
          }`}
          data-testid={`lang-${l.code}`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
